import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faPlus,
  faUndo,
  faUserCircle,
  faSignOutAlt,
  faFileAlt,
  faCalendarAlt,
  faClock,
  faRupeeSign,
  faChartLine,
  faVectorSquare,
  faBuilding,
  faExpandAlt,
} from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../../apiUrlConstant";
import TopHeader from "../../layout/TopHeader";
import { ChartPopup } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
var ReactS3Uploader = require("react-s3-uploader");
class AmendLeaseView extends React.Component {
  state = {
    redirect: false,
    leaseId: this.props.leaseId,
    leaseCode: this.props.leaseCode,
    costCenter: this.props.costCenter,

    amendMenus: this.props.amendMenus,
    amendleaseId: '',
    fileName: "-Amend-Doc.pdf",
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
  }

  componentDidMount() {
  }

  onUploadError() {
    this.setState({
      messsagePopup: true,
      popupContent: "Something Went Wrong!"
    });
    // alert("Something Went Wrong");
  }

  hidePopup() {
    this.props.setShow(false);
  }

  onUploadFinish = (e) => {
    var values = {
      leaseDocument: {
        leaseDocumentType: "Amend Document",
        leaseUploadDocumentDate: "2022-05-05",
        leaseDocumentUrl:
          fileUploadPath() +
          this.state.leaseId +
          "/" +
          this.state.fileName,
      },
    };
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/create-lease/upload-document?lease_id=${this.state.amendleaseId}`,

      data: values,
    }).then(function (response) {
      console.log(response.data.data);
      if (!response.data.success) {
      } else {
        self.state.documentTable = response.data.data;
        self.setState({});
      }
    });
    this.setState({
      messsagePopup: true,
      popupContent: "File Successfully Uploaded"
    });
    // alert("File Successfully Uploaded");
  };
  handleUpload() {
    //this.uploader.uploadFile();
    // const index = this.state.documentNames.indexOf(
    //   this.state.initialValues.leaseDocumentType
    // );
    // if (index > -1) {
    //   this.state.documentNames.splice(index, 1);
    // }
    // this.state.showUploadDocument = false;
    // this.setState({});
  }

  render() {
    return (
      <div>



        <Formik
          initialValues={{}}
          //enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values, "valuee....");
            var self = this;
            if(! self.props.formSubmitted ) {
              self.props.setFormSubmitted(true);
            
              axios({
                method: "post",
                url: `${apiUrl.apiUrl.url}/lease-view/amend-lease?leaseId=${this.state.leaseId}`,

                data: { checkedItems: values.option },
              }).then(function (response) {
                self.props.setFormSubmitted(false);
                if (!response.data.success) {
                  // alert("Something went wrong!!");
                  //setpopupMessageContent('Something went wrong.');
                  // console.log(popupMessageContent);
                  //setpopupalertMessage(true);
                } else {
                  self.setState({ amendleaseId: response.data.id, fileName: response.data.id + "-Amend-Doc.pdf" });
                  self.uploader.uploadFile();
                  self.hidePopup();
                  // alert("Details Stored successfully.");
                  // handleClose(false);
                  self.props.setpopupMessageContent('Details Stored successfully.');
                  self.props.setpopupalertMessage(true);
                  setTimeout(function () {
                    self.props.history.push(response.data.link);
                  }, 2000);
                }
              });
            }
          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <Form autoComplete="off" className="customTabs">
              <div className="unitFormContainer amend">
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-6 offset-lg-3">
                      <div className="tableContainer prospectTable mt-0">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Lease No
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.leaseCode}
                              </td>
                            </tr>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Cost Center
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.costCenter}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inputContainer">
                        <h4
                          className="fontPopins text-center"
                          style={{ fontSize: "16px" }}
                        >
                          Please select which screens to be amended
                        </h4>
                      </div>
                    </div>
                    <Field
                      type="hidden"
                      name="leaseId"
                      value={`${this.state.leaseId}`}
                      onChange={handleChange}
                    />

                    {this.state.amendMenus.length > 0 &&
                      this.state.amendMenus.map((pageItem, obj) => (
                        <div className="col-lg-6">
                          <div className="tableContainer screens">
                            <table className="table tableSimple tableSimpleWithNoFlex">
                              <thead>
                                <tr>
                                  <th>{pageItem.page}</th>
                                  <th>Amend</th>
                                </tr>
                              </thead>
                              <tbody>
                                {Object.keys(pageItem.list).map(
                                  (item) => (
                                    <tr>
                                      <td>
                                        <h5>
                                          {pageItem.list[item]["page"]}
                                        </h5>
                                      </td>

                                      <td>
                                        {pageItem.list[item][
                                          "canAmend"
                                        ] == true && (
                                            <Field
                                              type="checkbox"
                                              name={`option[${item}]`}
                                              className="sameAs"
                                            />
                                          )}

                                        {pageItem.list[item][
                                          "canAmend"
                                        ] == false && "N/A"}
                                      </td>
                                    </tr>
                                  )
                                )}
                              </tbody>
                            </table>
                          </div>

                        </div>
                      ))}
                    <div className="col-sm-7">
                      <ReactS3Uploader
                        signingUrl={`/site/get-s3signed-url`}
                        signingUrlMethod="GET"
                        accept="pdf/*"
                        s3path={`${fileUploadPath()}${this.state.leaseId}/`}
                        preprocess={this.onUploadStart}
                        onSignedUrl={this.onSignedUrl}
                        onProgress={this.onUploadProgress}
                        onError={this.onUploadError}
                        onFinish={this.onUploadFinish}
                        // signingUrlHeaders={{ additional: headers }}
                        // signingUrlQueryParams={{
                        //   additional: query - params,
                        // }}
                        signingUrlWithCredentials={false}
                        uploadRequestHeaders={
                          {
                            //"x-amz-acl": "public-read",
                          }
                        }
                        contentDisposition="attachment"
                        scrubFilename={() => this.state.fileName}
                        server={`${apiUrl.apiUrl.url}`}
                        inputRef={(cmp) => (this.uploadInput = cmp)}
                        autoUpload={false}
                        ref={(uploader) => {
                          this.uploader = uploader;
                        }}
                      />

                    </div>

                    <div class="button_group text-center mt-3">
                      <button type="submit" className="add_button">
                        Add
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>


      </div>
    );
  }
}

export default withRouter(AmendLeaseView);
